module.exports = __webpack_public_path__ + "img/picture_ksdgmn2.c883da6a.png";